import React from 'react';
import { useForm } from 'react-hook-form';
import MultiFactorPhoneNumberForm, {
  MultiFactorPhoneNumberFormValues,
} from '../../auth-views/components/MultiFactorPhoneNumberForm';
import { useMultiFactorMutation } from '../../../hooks/Auth';
import PhoneNumber from 'awesome-phonenumber';
import CenterLayout from '../../vendorlink-views/components/CenterLayout';
import ModalLayout from '../components/ModalLayout';
import { Button, Space } from 'antd';
import ErrorMessage from '../../auth-views/components/ErrorMessage';
import RecaptchaVerifierView from '../../auth-views/components/RecaptchaVerifierView';

interface EnrollPhoneNumberStepProps {
  onVerificationCodeSent: (phoneNumber: string, verificationId: string) => void;
  onCancel?: () => void;
}

const EnrollPhoneNumberStep: React.FC<EnrollPhoneNumberStepProps> = ({ onVerificationCodeSent, onCancel }) => {
  const { control, handleSubmit } = useForm<MultiFactorPhoneNumberFormValues>();
  const { useVerifyMultiFactor } = useMultiFactorMutation();
  const onPhoneNumberSubmit = async (values: MultiFactorPhoneNumberFormValues) => {
    const phoneNumber = PhoneNumber(values.phoneNumber, 'US');
    const e164PhoneNumber = phoneNumber.getNumber();
    const response = await useVerifyMultiFactor.mutateAsync({ phoneNumber: e164PhoneNumber });
    onVerificationCodeSent(e164PhoneNumber, response.verificationId);
  };
  return (
    <CenterLayout>
      <ModalLayout
        header={
          <Space direction="vertical">
            <div className="heading-xs">Secure your account with two-factor authentication</div>
            <div className="text-content-secondary">
              Protecting your account is our highest priority which is why we now require you to enable two-factor
              authentication to gain access to this page.
            </div>
            <div className="text-content-secondary">
              Enter a mobile phone you would like to use for SMS verification.
            </div>
          </Space>
        }
        content={
          <>
            <ErrorMessage />
            <MultiFactorPhoneNumberForm control={control} onSubmit={handleSubmit(onPhoneNumberSubmit)} />
          </>
        }
        footer={
          <Space>
            <Button
              disabled={useVerifyMultiFactor.isLoading}
              onClick={handleSubmit(onPhoneNumberSubmit)}
              type="primary"
            >
              Send verification code
            </Button>
            {onCancel && (
              <Button onClick={onCancel} type="text">
                Cancel
              </Button>
            )}
          </Space>
        }
      />
      <RecaptchaVerifierView />
    </CenterLayout>
  );
};

export default EnrollPhoneNumberStep;
